import * as React from 'react'

import formatPrice from '../../../common/utils/formatPrice'
import UsDollarsNoticeContainer from '../usDollarsNotice/usDollarsNoticeContainer'

const Magnifier = ({
  name,
  authorName,
  priceInCents,
  classification,
  width,
  height,
  children
}: {
  name: string
  authorName: string
  priceInCents: number | null
  classification: string
  width: number
  height?: number
  children?: React.ReactNode
}) => {
  return (
    <div className="magnifier" style={{ width }}>
      <div className="size-limiter" style={{ height }}>
        {children}
      </div>
      <strong>{name}</strong>
      <div className="info">
        <div className="author-category">
          by <span className="author">{authorName}</span>
        </div>
        {priceInCents ? (
          <div className="price">
            <span className="cost">
              <sup>$</sup>
              {formatPrice(priceInCents)}
            </span>
          </div>
        ) : null}
      </div>
      <div className="footer">
        <span className="category">{classification}</span>
        <UsDollarsNoticeContainer styleClassName="gst-notice" />
      </div>
    </div>
  )
}

export default Magnifier
